import {
  GIFT_SENT_SUCCESS,
  GIFT_SENT_FAIL,
  GIFT_INVESTMENT_FAIL,
  GIFT_INVESTMENT_SUCCESS,
  PURCHASE_DETAILS_FAIL,
  PURCHASE_DETAILS_SUCCESS,
  TXN_HISTORY,
  TXN_SUCCESS,
  TXN_FAIL,
  GET_MUTUAL_FUND_TRANSACTIONS,
} from "./types";
import {
  USER_BASE_URL,
  TRANSACTION_BASE_URL,
  API_BASE_URL,
  GOLD_SILVER_TRANSACTION,
  MF_TRANSACTION,
} from "../../Api/EndPoints";
import { APIClient } from "../../Api/APIClient";
import * as Models from "../../models";
/**************************************Transaction ****************************************************/

export function goldsilverTransaction(
  parameters: Models.TransactionGetRequest,
  token: any
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: TXN_HISTORY });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(
            TRANSACTION_BASE_URL +
              GOLD_SILVER_TRANSACTION +
              "?mobileNo=" +
              parameters.phoneNumber +
              "&txnType=" +
              parameters.selectedItem,
            token
          )
          .then((response: any) => {
            let result = response;
            txnSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            if (error?.status === 401) {
              txnSuccess(dispatch, error);
              resolve(error);
              return;
            }
            txnFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function mfTransaction(
  req: Models.MutualFundKYCRequestStatus,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND_TRANSACTIONS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_TRANSACTION, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}
const getSentSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  message: any
) => {
  dispatch({
    type: GIFT_SENT_SUCCESS,
    payload: message,
  });
};

const txnSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  message: any
) => {
  dispatch({
    type: TXN_SUCCESS,
    payload: message,
  });
};

const getSentFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_SENT_FAIL,
    payload: errorMessage,
  });
};
const getInvestmentFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_INVESTMENT_FAIL,
    payload: errorMessage,
  });
};
const getInvestmentSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_INVESTMENT_SUCCESS,
    payload: errorMessage,
  });
};
const txnFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: TXN_FAIL,
    payload: errorMessage,
  });
};

const getSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  message: any
) => {
  dispatch({
    type: PURCHASE_DETAILS_SUCCESS,
    payload: message,
  });
};

const getFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: PURCHASE_DETAILS_FAIL,
    payload: errorMessage,
  });
};
